import useAppSelector from '@/hooks/useAppSelector'
import { selectCurrentCompany } from '@/redux/slices/session'

export function useCurrentCompany() {
  return useAppSelector(selectCurrentCompany)
}
